/**
 * Objet représentant un élément dans un WizDivider
 */
export class WizDividerChildContent {

    /** L'élément enfant du wizDivider représenté */
    private _element: any;

    /** La taille actuelle de l'élément, largeur ou hauteur selon la direction */
    private _size: number;

    /** La taille minimale de l'élément, largeur min ou hauteur min selon la direction */
    private _minSize: number;

    /** La taille maximale de l'élément, largeur max ou hauteur max selon la direction */
    private _maxSize: number;

    /** direction du divider parent */
    private _direction: 'H'|'V';

    /** Objet contenant les marges avant/après selon la direction */
    private _elementMargins:WizDividerChildMargins = null;

    /** Stockage de la prochaine taille après redimensionnement */
    private _nextSize: number = 0;

    public maxSizeReached: boolean = false;

    /**
     * Constructeur
     * @param pElement L'élément enfant du divider
     * @param pDirection La direction du divider: 'H' pour horizontal, 'V' pour vertical
     */
    constructor(pElement: any, pDirection: 'H'|'V') {
      this._element = pElement;
      this._direction = pDirection;
      if (pDirection === 'V') {
        this._minSize = parseInt(this._element.style.minHeight, 10);
        if (!this._minSize) {
            this._minSize = 10;
        }
        this._maxSize = parseInt(this._element.style.maxHeight, 10);
      } else {
        this._minSize = parseInt(this._element.style.minWidth, 10);
        if (!this._minSize) {
            this._minSize = 10;
        }
        this._maxSize = parseInt(this._element.style.maxWidth, 10);
      }
    }

    /**
     * Accès à l'élément représenté
     */
    public getElement():any {
      return this._element;
    }

    /**
     * Acces à la taille actuelle
     */
    public getSize(): number {
      return this._size;
    }

    /**
     * Alimentation de la taille actuelle
     */
    public setSize(n:number) {
      this._size = n;
    }

    /**
     * Alimentation de la prochaine taille après redimensionnement
     */
    public setNextSize(pSize: number): void {
      this._nextSize = pSize;
    }

    /**
     * Accès à la prochaine taille après redimensionnement
     */
    public getNextSize(): number {
      return this._nextSize;
    }

    /**
     * Acces à la taille minimale
     */
    public getMinSize(): number {
      return this._minSize;
    }

    /**
     * Acces à la taille minimale
     */
    public getMaxSize(): number {
      return this._maxSize;
    }

    /**
     * Accès aux marges utiles selon la direction
     * @return WizDividerChildMargins
     */
    private getMargins(): WizDividerChildMargins {
      if (!this._elementMargins) {
        this._elementMargins = {
          before: parseFloat(this._direction === 'H' ? this._element.style.marginLeft: this._element.style.marginTop),
          after: parseFloat(this._direction === 'H' ? this._element.style.marginRight: this._element.style.marginBottom)
        };
        if (!this._elementMargins.before) {
          this._elementMargins.before = 0;
        }
        if (!this._elementMargins.after) {
          this._elementMargins.after = 0;
        }
      }
      return this._elementMargins;
    }

    /**
     * Retourne la dimension minimale, marges incluses
     */
    public getTotalMinSize(): number {
      const elementMargins = this.getMargins();
      return this._minSize + elementMargins.before + elementMargins.after;
    }

    /**
     * Retourne la dimension actuelle, marges incluses
     */
    public getTotalSize(): number {
      const elementMargins = this.getMargins();
      return this._size + elementMargins.before + elementMargins.after;
    }

  }

  /** Inteface représentant les marges avant/après selon la direction */
  export interface WizDividerChildMargins {
    before?: number;
    after?: number;
  }